module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoAgMAAADxkFD+AAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAUPodpYKIAAAAL0lEQVQY02MAAUYHBhhgmwBnSiOYeXAFjDsRSp8McqVQJkIBQhvCsCGiGMJERBYAhEAcSXVWDmUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/backIcon.png
// module id = /MYA
// module chunks = 317